var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"catalog-list"},[_vm._l((_vm.catalogs),function(catalog){return _c('li',{key:catalog.id,staticClass:"catalog-list__item"},[_c('a',{on:{"click":function($event){return _vm.$router.push({
          name: 'editCatalog',
          params: { id: catalog.id, module: catalog.type },
        })}}},[_vm._v(" "+_vm._s(catalog.name)+" ")])])}),(_vm.hasMissingCatalog)?_c('li',{staticClass:"catalog-list__item--add"},[_c('a',{on:{"click":function($event){return _vm.$router.push('/catalogs')}}},[_c('b-icon',{attrs:{"icon":"playlist-plus"}})],1)]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }